export enum SoldCampaignReceivableStatus {
  Unsubmitted = 'Unsubmitted',
  WaitingForAuthorisation = 'WaitingForAuthorisation',
  WaitingForApproval = 'WaitingForApproval',
  Invalid = 'Invalid',
  Approved = 'Approved',
  Submitted = 'Submitted',
  Cancelled = 'Cancelled'
}
